/*
  Mobiel uitklapmenu voor de FitTowel header. Staat niet in het Figma-design
  (dat is alleen op 1440px getekend) — nodig zodra de navigatie op smalle
  schermen wordt verborgen.
*/
if (!customElements.get('ft-header')) {
  customElements.define(
    'ft-header',
    class FtHeader extends HTMLElement {
      connectedCallback() {
        this.toggle = this.querySelector('[data-header-toggle]');
        this.drawer = this.querySelector('[data-header-drawer]');
        if (!this.toggle || !this.drawer) return;

        this.onToggle = () => this.setOpen(!this.isOpen);
        this.onKeydown = (event) => {
          if (event.key === 'Escape' && this.isOpen) {
            this.setOpen(false);
            this.toggle.focus();
          }
        };
        this.onLinkClick = () => this.setOpen(false);

        this.toggle.addEventListener('click', this.onToggle);
        this.addEventListener('keydown', this.onKeydown);
        this.drawer.querySelectorAll('a').forEach((link) => {
          link.addEventListener('click', this.onLinkClick);
        });
      }

      disconnectedCallback() {
        this.toggle?.removeEventListener('click', this.onToggle);
        this.removeEventListener('keydown', this.onKeydown);
      }

      get isOpen() {
        return this.toggle.getAttribute('aria-expanded') === 'true';
      }

      setOpen(open) {
        this.toggle.setAttribute('aria-expanded', String(open));
        this.drawer.hidden = !open;
        this.classList.toggle('ft-header--drawer-open', open);
        document.body.classList.toggle('ft-header-drawer-locked', open);
      }
    }
  );
}
